module.exports = __webpack_public_path__ + "static/media/choithramsCompass.3a27189b.png";